/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdProgressProps } from './type';

export const progressDefaultProps: TdProgressProps = { label: true, percentage: 0, size: 'medium', theme: 'line' };
